import { render, staticRenderFns } from "./perDayPerTerminal.vue?vue&type=template&id=1b58197e"
import script from "./perDayPerTerminal.vue?vue&type=script&lang=js"
export * from "./perDayPerTerminal.vue?vue&type=script&lang=js"
import style0 from "./perDayPerTerminal.vue?vue&type=style&index=0&id=1b58197e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports